import './PortCustomTitleBar.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Space } from 'antd'
import {
  SearchOutlined,
  MenuOutlined,
  CloseOutlined,
  HomeOutlined,
} from '@ant-design/icons'
import Logo5 from '../../images/company/logo5.png'

export default class PortCustomTitleBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {}

  render() {
    return (
      <div ref={this.props.titleBarRef} className="PortCustomTitleBar">
        <Space size={'middle'} style={{ width: 126 }}>
          {this.getMenuIcon()}
          {this.getHomeIcon()}
        </Space>

        <div className="PortCompanyLogoWrapper">
          <img
            src={Logo5}
            className="PortCompanyLogo"
            onClick={() => this.backToMainPage()}
          />
        </div>

        <div
          className="PortCustomTitleBarSearchWrapper"
          onClick={this.viewProductList}
        >
          <div className="PortCustomTitleBarSearchText">检索公司产品</div>
          <SearchOutlined style={{ fontSize: 16, color: 'white' }} />
        </div>
      </div>
    )
  }

  getMenuIcon = () => {
    return this.props.menuExpanded ? (
      <CloseOutlined
        style={{ color: 'white', fontSize: 17 }}
        onClick={this.props.changeMenuExpandedState}
      />
    ) : (
      <MenuOutlined
        style={{ color: 'white', fontSize: 17 }}
        onClick={this.props.changeMenuExpandedState}
      />
    )
  }

  getHomeIcon = () => {
    return (
      <HomeOutlined
        style={{ color: 'white', fontSize: 17 }}
        onClick={() => {
          this.backToMainPage()
          this.props.collapseMenu()
        }}
      />
    )
  }

  backToMainPage = () => {
    this.props.history.push('/')
  }

  viewProductList = () => {
    this.props.history.push('/product_list')
  }

  gotoShop = () => {
    window.open('https://mall.jd.com/index-12045041.html', '_blank')
  }
}
